//

(function() {
  const curalate = angular.module('curalate');

    // This directive is mostly copied from https://docs.angularjs.org/api/ng/type/ngModel.NgModelController#custom-control-example
  curalate.directive('angularContenteditable', ['$sce',
    function($sce) {
      return {
        restrict: 'A', // only activate on element attribute
        require: '?ngModel', // get a hold of NgModelController
        link(scope, element, attrs, ngModel) {
                    // do nothing if no ng-model
          if (!ngModel) {
            return;
          }

                    // Specify how UI should be updated
          ngModel.$render = function() {
            element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
          };

                    // Listen for change events to enable binding
          element.on('blur keyup change', () => {
            scope.$evalAsync(read);
          });

                    // Write data to the model
          function read() {
            let html = element.html();
                        // When we clear the content editable the browser leaves a <br> behind
                        // If strip-br attribute is provided then we strip this out
            if (attrs.stripBr && html === '<br>') {
              html = '';
            }
            ngModel.$setViewValue(html);
          }

          const validateContentEditableLengthFunc = function() {
            const rawText = element[0].innerText || element[0].textContent;

            return rawText.length < attrs.contenteditableMaxlength;
          };

          const initialize = function() {
            if (attrs.contenteditableMaxlength) {
              ngModel.$validators.contenteditablemaxlength = validateContentEditableLengthFunc;

              validateContentEditableLengthFunc();
            }

            element.attr('contenteditable', '');
            read();
          };

          initialize();
        },
      };
    },
  ]);
})();
